
import { renderToString } from 'preact-render-to-string';
import { MwlIcons } from "../components/MwlIcons";
import  i18n from '@i18n';

export const initSlideshow = (lightbox, slideshowConfig) => {

  let slideshowInterval;


  lightbox.on('uiRegister', () => {

    let isPlaying = slideshowConfig.autoplay;

    if( slideshowConfig.autoplay ) {
      slideshowInterval = setInterval(() => {
        lightbox.pswp.next();
      }, slideshowConfig.slide_duration);
    }

    const playIcon = <MwlIcons icon={'play'} />;
    const pauseIcon = <MwlIcons icon={'pause'} />;

    const updateButton = (el) => {
      el.innerHTML = isPlaying ? renderToString(pauseIcon) : renderToString(playIcon);
      el.dataset.tooltip = isPlaying ? i18n.TOOLBAR.PAUSE : i18n.TOOLBAR.PLAY;
    };

    lightbox.pswp.ui.registerElement({
      name: 'slideshow-button',
      order: 9,
      ariaLabel: isPlaying ? i18n.TOOLBAR.PAUSE : i18n.TOOLBAR.PLAY,
      isButton: true,
      html: renderToString(isPlaying ? pauseIcon : playIcon),
      onInit: (el) => {
        el.dataset.tooltip = isPlaying ? i18n.TOOLBAR.PAUSE : i18n.TOOLBAR.PLAY;
      },
      onClick: (event, el) => {
        isPlaying = !isPlaying;
        updateButton(el);
        const eventName = isPlaying ? 'startSlideshow' : 'stopSlideshow';
        const customEvent = new Event(eventName);
        document.dispatchEvent(customEvent);
      },
    });
  });

  
  lightbox.on('bindEvents', () => {

    document.addEventListener('startSlideshow', () => {
      clearInterval(slideshowInterval);
      slideshowInterval = setInterval(() => {
        lightbox.pswp.next();
      }, slideshowConfig.slide_duration);
    });

    document.addEventListener('stopSlideshow', () => {
      clearInterval(slideshowInterval);
    });
  });

  lightbox.on('close', () => {
    clearInterval(slideshowInterval);
  });
};